import { render, staticRenderFns } from "./form_seminar.vue?vue&type=template&id=41dab37d&scoped=true&"
import script from "./form_seminar.vue?vue&type=script&lang=js&"
export * from "./form_seminar.vue?vue&type=script&lang=js&"
import style0 from "./form_seminar.vue?vue&type=style&index=0&id=41dab37d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dab37d",
  null
  
)

export default component.exports